import { useQuery, useMutation } from '@tanstack/react-query';
import { apiGet, apiPost } from '../api/client.js';

export const useCaeRequests = (filters = {}) =>
  useQuery({
    queryKey: ['cae-requests', filters],
    queryFn: () => apiGet('/cae-requests', { params: filters }),
  });

export const useCaeRequestsCountToday = () =>
  useQuery({ queryKey: ['cae-requests', 'count-today'], queryFn: () => apiGet('/cae-requests/count-today') });

// No invalida queries ni cachea el resultado -- es una verificación puntual
// contra ARCA (FECompConsultar), no cambia nada de lo que ya tenemos guardado.
export const useConsultarEnArca = () =>
  useMutation({
    mutationFn: (id) => apiPost(`/cae-requests/${id}/consultar-arca`),
  });

// Busca si el comprobante asociado de una NC/ND ya está en nuestros
// registros -- es una lectura liviana de nuestra propia DB, se puede
// disparar sola apenas se conoce el comprobante asociado (a diferencia de
// la consulta a ARCA, que sí queda detrás de un botón).
export const useBuscarPorComprobante = (params) =>
  useQuery({
    queryKey: ['cae-requests', 'buscar-por-comprobante', params],
    queryFn: () => apiGet('/cae-requests/buscar-por-comprobante', { params }),
    enabled: !!params,
  });

// Mismo FECompConsultar que useConsultarEnArca, pero por ptoVta/cbteTipo/cbteNro
// directos -- hace falta para un comprobante asociado que puede no tener fila
// propia en cae_requests (ej. una factura emitida antes de este sistema).
export const useConsultarComprobanteArca = () =>
  useMutation({
    mutationFn: (params) => apiPost('/cae-requests/consultar-comprobante-arca', params),
  });
